import React from 'react';
import { observer } from 'mobx-react';

const withLegend = Component => {

  @observer
  class WithLegendComponent extends React.Component {

    render() {
      const { legend, ...restProps } = this.props;

      if (legend) {
        return (
          <fieldset>
            <legend>{legend}</legend>
            <Component {...restProps} />
          </fieldset>
        );
      }

      return <Component {...this.props} />;
    }
  }

  return WithLegendComponent;
};

withLegend.displayName = 'withLegend';
export default withLegend;